(function () {
  if (window.FAR_B2C_NORMALIZED) return;

  function clean(value) {
    return String(value || '').replace(/\s*·\s*/g, ' · ').replace(/\s+/g, ' ').trim();
  }
  function joinVariant(suffix, variant) {
    return clean([clean(suffix), clean(variant)].filter(Boolean).join(' · '));
  }
  function appendVariant(variant, suffix) {
    return clean([clean(variant), clean(suffix)].filter(Boolean).join(' · '));
  }
  function joinUniqueParts() {
    var seen = {};
    var parts = [];
    Array.prototype.slice.call(arguments).forEach(function (value) {
      clean(value).split(/\s*·\s*/).filter(Boolean).forEach(function (part) {
        var key = part.toLocaleLowerCase('it');
        if (!seen[key]) {
          seen[key] = true;
          parts.push(part);
        }
      });
    });
    return clean(parts.join(' · '));
  }
  function setExplicit(fitment, model, variant) {
    fitment[1] = clean(model);
    fitment[2] = clean(variant);
    return true;
  }
  function splitLeadingNumeric(variant) {
    var match = clean(variant).match(/^(\d{2,4})(?:\s*·\s*(.*))?$/);
    return match ? { number: match[1], rest: clean(match[2]) } : null;
  }
  function variantParts(value) {
    return clean(value).split(/\s*·\s*/).map(clean).filter(Boolean);
  }
  function setModelParts(fitment, model, parts) {
    return setExplicit(fitment, model, joinUniqueParts.apply(null, parts || []));
  }
  function removeMatchingParts(parts, pattern) {
    return parts.filter(function (part) { return !pattern.test(part); });
  }
  function normalizeDistinctCommercialModel(fitment) {
    var brand = fitment[0];
    var model = clean(fitment[1]);
    var variant = clean(fitment[2]);
    var parts = variantParts(variant);
    var match;

    if (brand === 'APRILIA') {
      match = model.match(/^(Caponord|Dorsoduro)(?:\s+(.+))?$/i);
      if (match) {
        var apriliaModelText = clean([match[2], variant].join(' · '));
        var apriliaModelNumber = (apriliaModelText.match(/\b(750|1200)\b/) || [])[1] || '';
        if (apriliaModelNumber) {
          var apriliaModelTrims = variantParts(apriliaModelText).filter(function (part) {
            return !new RegExp('^' + apriliaModelNumber + '$').test(part);
          });
          return setModelParts(fitment, match[1] + ' ' + apriliaModelNumber, apriliaModelTrims);
        }
      }
      if (/^(Caponord|Dorsoduro)$/i.test(model) && parts.length && /^(750|1200)$/.test(parts[parts.length - 1])) {
        var apriliaFamily = model.replace(/^./, function (value) { return value.toUpperCase(); });
        var apriliaNumber = parts.pop();
        return setModelParts(fitment, apriliaFamily + ' ' + apriliaNumber, parts);
      }
      if (/^RS$/i.test(model) && parts.length && /^(125|250|660)$/.test(parts[0])) {
        var rsNumber = parts.shift();
        return setModelParts(fitment, 'RS ' + rsNumber, removeMatchingParts(parts, /^RS$/i));
      }
      if (/^660 4T 8v$/i.test(model) && /^RS$/i.test(variant)) return setExplicit(fitment, 'RS 660', '4T 8V');
      if (/^Tuono/i.test(model)) {
        var tuonoText = clean([model.replace(/^Tuono\s*/i, ''), variant].join(' · '));
        var tuonoNumber = (tuonoText.match(/\b(50|125|660|1000|1100)\b/) || [])[1] || '';
        if (tuonoNumber) {
          var tuonoV4 = /\bV4\b/i.test(tuonoText) || /^(1000|1100)$/.test(tuonoNumber);
          var tuonoTrims = variantParts(tuonoText).filter(function (part) {
            return !new RegExp('^(?:Tuono|' + tuonoNumber + '|V4)$', 'i').test(part);
          });
          return setModelParts(fitment, 'Tuono ' + (tuonoV4 ? 'V4 ' : '') + tuonoNumber, tuonoTrims);
        }
      }
      if (/^RSV Tuono$/i.test(model)) {
        var rsvTuonoNumber = (variant.match(/\b(1000|1100)\b/) || [])[1] || '1000';
        return setModelParts(fitment, 'Tuono V4 ' + rsvTuonoNumber, removeMatchingParts(parts, new RegExp('^(?:' + rsvTuonoNumber + '|V4)$', 'i')));
      }
    }

    /* Motorcycle model codes are not generic families: F 750 GS, CB650R,
       Z900RS, TRK 502 X, etc. must remain selectable as distinct models. */
    if (brand === 'BMW') {
      if (/^R nineT$/i.test(model)) {
        var nineTTrim = parts.find(function (part) { return /^(Pure|Scrambler|Urban G\/S)$/i.test(part); });
        if (nineTTrim) {
          return setModelParts(fitment, 'R nineT ' + nineTTrim, removeMatchingParts(parts, /^(1200|Pure|Scrambler|Urban G\/S)$/i));
        }
        return setModelParts(fitment, 'R nineT', removeMatchingParts(parts, /^1200$/i));
      }
      match = model.match(/^([CFGKMRS])(?:\s+(\d{3,4}))?(?:\s+(.+))?$/i);
      if (match) {
        var series = match[1].toUpperCase();
        var number = match[2] || '';
        var rawSuffix = clean(match[3]);
        var bmwParts = parts.slice();
        if (!number && bmwParts.length && /^\d{3,4}$/.test(bmwParts[0])) number = bmwParts.shift();
        if (number && bmwParts.length && /^\d{3,4}$/.test(bmwParts[0]) && bmwParts[0] !== number) bmwParts.shift();
        if (bmwParts.length > 1 && /^R$/i.test(bmwParts[bmwParts.length - 1]) && /^(GS|RS)$/i.test(bmwParts[bmwParts.length - 2])) bmwParts.pop();
        var body = rawSuffix;
        if (!body && bmwParts.length) body = bmwParts.shift();
        if (/^Rockster$/i.test(body) && bmwParts.some(function (part) { return /^R$/i.test(part); })) {
          body = 'R Rockster';
          bmwParts = removeMatchingParts(bmwParts, /^R$/i);
        }
        if (/^(GS|R|S|RS|GT|XR|CS|Sport)$/i.test(body) && bmwParts.length && /^(Adventure|Dakar|Sertao|Sport)$/i.test(bmwParts[0])) {
          body += ' ' + bmwParts.shift();
        }
        if (number) return setModelParts(fitment, clean(series + ' ' + number + (body ? ' ' + body : '')), bmwParts);
      }
    }

    if (brand === 'BENELLI') {
      match = model.match(/^BN\s*(125|302|600)$/i);
      if (match) return setModelParts(fitment, 'BN ' + match[1], removeMatchingParts(parts, new RegExp('^' + match[1] + '$')));
      if (/^BN$/i.test(model) && parts.length && /^(125|302|600)$/.test(parts[0])) {
        var bnNumber = parts.shift();
        return setModelParts(fitment, 'BN ' + bnNumber, removeMatchingParts(parts, new RegExp('^' + bnNumber + '$')));
      }
      match = model.match(/^TRK(?:\s+(251|502|702))?$/i);
      if (match) {
        var trkNumber = match[1] || (parts.length && /^(251|502|702)$/.test(parts[0]) ? parts.shift() : '');
        if (trkNumber) {
          parts = removeMatchingParts(parts, new RegExp('^(?:' + trkNumber + '|' + (trkNumber === '251' ? '250' : trkNumber === '502' ? '500' : '702') + ')$'));
          var trkX = parts.some(function (part) { return /^X$/i.test(part); });
          parts = removeMatchingParts(parts, /^X$/i);
          return setModelParts(fitment, 'TRK ' + trkNumber + (trkX ? ' X' : ''), parts);
        }
      }
      match = model.match(/^Leoncino(?:\s+(500|800))?(?:\s+(Trail))?$/i);
      if (match) {
        var leoncinoNumber = match[1] || (parts.length && /^(500|800)$/.test(parts[0]) ? parts.shift() : '');
        var leoncinoTrail = match[2] || (parts.some(function (part) { return /^Trail$/i.test(part); }) ? 'Trail' : '');
        if (leoncinoNumber) {
          parts = removeMatchingParts(parts, new RegExp('^(?:' + leoncinoNumber + '|Trail)$', 'i'));
          return setModelParts(fitment, 'Leoncino ' + leoncinoNumber + (leoncinoTrail ? ' Trail' : ''), parts);
        }
      }
      if (/^TNT$/i.test(model) && parts.length && /^\d{3,4}$/.test(parts[0])) {
        return setModelParts(fitment, 'TNT ' + parts.shift(), parts);
      }
      if (/^TRK$/i.test(model) && /^500$/.test(variant)) return setExplicit(fitment, 'TRK 502', '');
    }

    if (brand === 'HONDA') {
      if (/^CB F Hornet S$/i.test(model) && /^600$/i.test(variant)) return setExplicit(fitment, 'CB600F Hornet', 'S');
      if (/^CB 600 S F2 Hornet S$/i.test(model)) return setExplicit(fitment, 'CB600F Hornet', joinUniqueParts('F2', 'S', variant));
      if (/^CB$/i.test(model) && /^600\s*·\s*F Hornet S$/i.test(variant)) return setExplicit(fitment, 'CB600F Hornet', 'S');
      if (/^CB$/i.test(model) && /^600\s*·\s*S F2 Hornet S$/i.test(variant)) return setExplicit(fitment, 'CB600F Hornet', 'F2 · S');
      if (/^CB$/i.test(model) && /^750\s*·\s*Hornet$/i.test(variant)) return setExplicit(fitment, 'CB750 Hornet', '');
      if (/^CB750$/i.test(model) && /^Hornet$/i.test(variant)) return setExplicit(fitment, 'CB750 Hornet', '');
      if (/^CB$/i.test(model) && /^1000\s*·\s*F Big One$/i.test(variant)) return setExplicit(fitment, 'CB1000 Big One', 'F');
      if (/^CB$/i.test(model) && /^1300\s*·\s*F Super Four$/i.test(variant)) return setExplicit(fitment, 'CB1300 Super Four', 'F');
      if (/^CBR 600$/i.test(model)) {
        if (/^(?:600\s*·\s*)?F$/i.test(variant)) return setExplicit(fitment, 'CBR600F', '');
        if (/^F Sport$/i.test(variant)) return setExplicit(fitment, 'CBR600F Sport', '');
        if (/^RR$/i.test(variant)) return setExplicit(fitment, 'CBR600RR', '');
      }
      if (/^CBR 900 Fireblade$/i.test(model) && /^RR$/i.test(variant)) return setExplicit(fitment, 'CBR900RR Fireblade', '');
      if (/^CBR 1000(?: Fireblade)?$/i.test(model) && /^RR$/i.test(variant)) return setExplicit(fitment, 'CBR1000RR' + (/Fireblade/i.test(model) ? ' Fireblade' : ''), '');
      if (/^CRF300 Rally$/i.test(model)) return setExplicit(fitment, 'CRF300 Rally', variant);
      if (/^CBR 600 Ra$/i.test(model)) return setExplicit(fitment, 'CBR600RA', variant);
      if (/^Cbf 600 Naked$/i.test(model)) return setExplicit(fitment, 'CBF600N', joinUniqueParts('Naked', variant));
      if (/^Cbf$/i.test(model) && parts.length && /^(500|600)$/.test(parts[0])) {
        var cbfNumber = parts.shift();
        var cbfSuffix = parts.length && /^(N|Na)$/i.test(parts[0]) ? parts.shift().toUpperCase() : '';
        return setModelParts(fitment, 'CBF' + cbfNumber + cbfSuffix, parts);
      }
      match = model.match(/^(CBR|CBF|CB|CRF|NC|VFR)\s*(\d{2,4})(.*)$/i);
      if (match) {
        var hondaFamily = match[1].toUpperCase();
        var hondaSuffix = clean(match[3]).replace(/^\s+/, '');
        if (hondaFamily === 'CRF' && /^1100\s*Africa Twin$/i.test(match[2] + ' ' + hondaSuffix)) {
          return setModelParts(fitment, 'Africa Twin', ['1100'].concat(parts));
        }
        if (hondaFamily === 'VFR' && /^800/i.test(match[2])) {
          return setModelParts(fitment, 'VFR800', [hondaSuffix].concat(parts));
        }
        if (hondaFamily === 'CRF' && /^Rally$/i.test(hondaSuffix)) {
          return setModelParts(fitment, 'CRF' + match[2] + ' Rally', parts);
        }
        if (hondaFamily === 'CBR' && /^Fireblade$/i.test(hondaSuffix)) {
          var rrCode = parts.some(function (part) { return /^RR$/i.test(part); }) ? 'RR' : '';
          return setModelParts(fitment, 'CBR' + match[2] + rrCode + ' Fireblade', removeMatchingParts(parts, /^RR$/i));
        }
        var wordSuffix = /^(Hornet|Big One|Super Four)/i.test(hondaSuffix) ? ' ' + hondaSuffix : hondaSuffix;
        var hondaModel = hondaFamily + match[2] + wordSuffix.replace(/\s+/g, ' ');
        parts = removeMatchingParts(parts, new RegExp('^' + match[2] + '$'));
        return setModelParts(fitment, hondaModel, parts);
      }
      if (/^CB$/i.test(model) && parts.length && /^\d{3,4}(?:[FR])?$/i.test(parts[0])) {
        var cbCode = parts.shift();
        var cbName = '';
        if (parts.length && /^(F|R|SS)$/i.test(parts[0])) cbCode += parts.shift().toUpperCase();
        if (parts.length && /^(Hornet|Big One|Super Four)$/i.test(parts[0])) cbName = ' ' + parts.shift();
        if (/^600$/i.test(cbCode) && /Hornet/i.test(cbName)) cbCode = '600F';
        return setModelParts(fitment, 'CB' + cbCode + cbName, removeMatchingParts(parts, /^(F|R)$/i));
      }
      if (/^CBR$/i.test(model) && parts.length && /^\d{3,4}$/.test(parts[0])) {
        var cbrNumber = parts.shift();
        var cbrCode = '';
        if (parts.length && new RegExp('^' + cbrNumber + '\\s+F$', 'i').test(parts[0])) {
          cbrCode = 'F';
          parts.shift();
        }
        if (parts.length && /^F Sport$/i.test(parts[0])) {
          cbrCode = 'F';
          parts[0] = 'Sport';
        }
        if (parts.length && /^(F|RR|R)$/i.test(parts[0])) cbrCode = parts.shift().toUpperCase();
        if (!cbrCode && cbrNumber === '125') cbrCode = 'R';
        var cbrSport = parts.length && /^Sport$/i.test(parts[0]) ? ' Sport' : '';
        if (cbrSport) parts.shift();
        var fireblade = parts.some(function (part) { return /^Fireblade$/i.test(part); });
        if (fireblade && parts.some(function (part) { return /^RR$/i.test(part); })) cbrCode = 'RR';
        parts = removeMatchingParts(parts, /^(Fireblade|R|RS|Rw)$/i);
        return setModelParts(fitment, 'CBR' + cbrNumber + cbrCode + cbrSport + (fireblade ? ' Fireblade' : ''), parts);
      }
      if (/^CRF$/i.test(model) && parts.length && /^\d{3,4}$/.test(parts[0])) {
        var crfNumber = parts.shift();
        var crfSuffix = parts.length && /^(L|Rally)$/i.test(parts[0]) ? parts.shift() : '';
        return setModelParts(fitment, 'CRF' + crfNumber + (/^Rally$/i.test(crfSuffix) ? ' Rally' : crfSuffix), parts);
      }
      if (/^NC$/i.test(model) && parts.length && /^(700|750)$/.test(parts[0])) {
        var ncNumber = parts.shift();
        var ncText = parts.join(' ');
        var ncSuffix = /(?:^|\s)S(?:\s|$)/i.test(ncText) && !/X/i.test(ncText) ? 'S' : 'X';
        return setModelParts(fitment, 'NC' + ncNumber + ncSuffix, []);
      }
      if (/^VFR$/i.test(model) && parts.length && /^800$/.test(parts[0])) {
        parts.shift();
        return setModelParts(fitment, 'VFR800', parts);
      }
      if (/^VFR X Cross Runner$/i.test(model)) return setExplicit(fitment, 'VFR800X Crossrunner', '');
    }

    if (brand === 'KAWASAKI') {
      if (/^Zr 800$/i.test(model)) return setExplicit(fitment, 'Z800', '');
      if (/^Vulcan$/i.test(model) && /^S$/i.test(variant)) return setExplicit(fitment, 'Vulcan S', '');
      match = model.match(/^Z\s*(650|750|800|900|1000)(RS|R|SX)?$/i);
      if (match) return setModelParts(fitment, 'Z' + match[1] + (match[2] || '').toUpperCase(), removeMatchingParts(parts, new RegExp('^' + match[1] + '$')));
      if (/^Z$/i.test(model) && parts.length && /^(650|750|800|900|1000)$/.test(parts[0])) {
        var zNumber = parts.shift();
        var zCode = parts.length && /^(RS|R|SX)$/i.test(parts[0]) ? parts.shift().toUpperCase() : '';
        if (parts.some(function (part) { return /^H2$/i.test(part); })) {
          parts = removeMatchingParts(parts, /^H2$/i);
          return setModelParts(fitment, 'Z H2', parts);
        }
        return setModelParts(fitment, 'Z' + zNumber + zCode, parts);
      }
      match = model.match(/^Ninja(?:\s+(.+))?$/i);
      if (match) {
        var ninjaCode = clean(match[1]) || (parts.length ? parts.shift() : '');
        if (ninjaCode && /^(?:500R?|650|1000|ZX[- ]?\d{1,2}R{0,2})$/i.test(ninjaCode)) {
          return setModelParts(fitment, 'Ninja ' + ninjaCode.replace(/^ZX[- ]*/i, 'ZX-').replace(/r$/i, 'R'), removeMatchingParts(parts, new RegExp('^' + ninjaCode.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '$', 'i')));
        }
      }
      match = model.match(/^Versys(?:-X)?(?:\s+(300|650))?$/i);
      if (match) {
        var versysNumber = match[1] || (parts.length && /^(300|650)$/.test(parts[0]) ? parts.shift() : '');
        if (versysNumber) return setModelParts(fitment, (/-X/i.test(model) ? 'Versys-X ' : 'Versys ') + versysNumber, parts);
      }
      match = model.match(/^(?:VN|Vulcan)(?:\s+(900|1700|2000))?(?:\s+(.+))?$/i);
      if (match) {
        var vulcanNumber = match[1] || (parts.length && /^(900|1700|2000)$/.test(parts[0]) ? parts.shift() : '');
        var vulcanBody = clean(match[2]) || (parts.length && /^(Classic|Nomad|Vaquero|Voyager)$/i.test(parts[0]) ? parts.shift() : '');
        if (vulcanNumber) return setModelParts(fitment, 'Vulcan ' + vulcanNumber + (vulcanBody ? ' ' + vulcanBody : ''), parts);
      }
    }

    if (brand === 'KYMCO') {
      match = model.match(/^Agility City(?:\s+(50|125|150|200))?$/i);
      if (match) return setModelParts(fitment, 'Agility City', [match[1]].concat(parts));
      if (/^Agility 50$/i.test(model) && /RS/i.test(variant)) {
        var agilityNaked = /Naked/i.test(variant);
        parts = removeMatchingParts(parts, /^(RS|Naked)$/i);
        return setModelParts(fitment, agilityNaked ? 'Agility RS Naked' : 'Agility RS', ['50'].concat(parts));
      }
      if (/^Agility(?:\s+50)?$/i.test(model)) {
        var agilityText = clean([model.replace(/^Agility/i, ''), variant].join(' · '));
        var agilityNumber = (agilityText.match(/\b(50|125|150|200)\b/) || [])[1] || '';
        var agilityEngine = (agilityText.match(/\b(2T|4T)\b/i) || [])[1] || '';
        if (/City\s*16\+/i.test(agilityText)) return setModelParts(fitment, 'Agility City 16+', [agilityNumber, agilityEngine]);
        if (/16\+|\bPlus\b/i.test(agilityText)) return setModelParts(fitment, 'Agility R16 Plus', [agilityNumber, agilityEngine]);
        if (/\bDelivery\b/i.test(agilityText)) return setModelParts(fitment, 'Agility Delivery', [agilityNumber, agilityEngine]);
        if (/Naked\s+Renouvo/i.test(agilityText)) return setModelParts(fitment, 'Agility Naked Renouvo', [agilityNumber, agilityEngine]);
      }
      if (/^People(?:\s+.*)?$/i.test(model)) {
        var peopleText = clean([model.replace(/^People/i, ''), variant].join(' · '));
        var peopleNumber = (peopleText.match(/\b(50|125|150|200|300)\b/) || [])[1] || '';
        var peopleEngine = (peopleText.match(/\b(2T|4T)\b/i) || [])[1] || '';
        if (/\b(?:GTI|GT)\b/i.test(peopleText)) return setModelParts(fitment, 'People GTi', [peopleNumber, peopleEngine]);
        if (/\bOne\b/i.test(peopleText)) return setModelParts(fitment, 'People One', [peopleNumber, peopleEngine]);
        if (/\bS\b/i.test(peopleText)) return setModelParts(fitment, 'People S', [peopleNumber, peopleEngine]);
      }
    }

    if (brand === 'SUZUKI') {
      if (/^GSX1400$/i.test(model)) return setExplicit(fitment, 'GSX1400', variant);
      if (/^GSX W$/i.test(model) && /^750\s*·\s*R$/i.test(variant)) return setExplicit(fitment, 'GSX-R 750', 'W');
      if (/^GSX$/i.test(model) && /^1400(?:\s*·\s*Z)?$/i.test(variant)) return setExplicit(fitment, 'GSX1400', /Z$/i.test(variant) ? 'Z' : '');
      if (/^GSX-F$/i.test(model) && parts.length && /^(600|750)$/.test(parts[0])) return setModelParts(fitment, 'GSX-F ' + parts.shift(), parts);
      if (/^SV$/i.test(model) && !variant) return setExplicit(fitment, 'SV650', '');
      if (/^GSX$/i.test(model) && parts.length && /^\d{3,4}$/.test(parts[0]) && parts.some(function (part) { return /^R$/i.test(part); })) {
        var gsxrNumber = parts.shift();
        parts = removeMatchingParts(parts, /^R$/i);
        return setModelParts(fitment, 'GSX-R ' + gsxrNumber, parts);
      }
      match = model.match(/^GSX(?:[- ]?F)?\s*(600|750)F?$/i);
      if (match) return setModelParts(fitment, 'GSX-F ' + match[1], removeMatchingParts(parts, new RegExp('^' + match[1] + '$')));
      match = model.match(/^GSX-S(?:\s+(1000))?$/i);
      if (match) {
        var gsxsNumber = match[1] || (parts.length && /^1000$/.test(parts[0]) ? parts.shift() : '');
        if (gsxsNumber) return setModelParts(fitment, 'GSX-S ' + gsxsNumber, parts);
      }
      match = model.match(/^SV\s*(650|1000)?(?:\s*([NS]))?$/i);
      if (match) {
        var svNumber = match[1] || (parts.length && /^(650|1000)$/.test(parts[0]) ? parts.shift() : '');
        var svSuffix = match[2] || (parts.length && /^[NS]$/i.test(parts[0]) ? parts.shift() : '');
        if (svNumber) return setModelParts(fitment, 'SV' + svNumber + (svSuffix ? svSuffix.toUpperCase() : ''), parts);
      }
      match = model.match(/^TL(?:\s+(1000))?(?:\s+([RS]))?$/i);
      if (match) {
        var tlNumber = match[1] || (parts.length && /^1000$/.test(parts[0]) ? parts.shift() : '');
        var tlSuffix = match[2] || (parts.length && /^[RS]$/i.test(parts[0]) ? parts.shift() : '');
        if (tlNumber && tlSuffix) return setModelParts(fitment, 'TL' + tlNumber + tlSuffix.toUpperCase(), parts);
      }
      if (/^V-Strom$/i.test(model) && parts.length && /^(650|800|1000|1050)$/i.test(parts[0])) {
        var stromNumber = parts.shift();
        var stromSuffix = parts.length && /^(XT|DE)$/i.test(parts[0]) ? ' ' + parts.shift().toUpperCase() : '';
        return setModelParts(fitment, 'V-Strom ' + stromNumber + stromSuffix, parts);
      }
      if (/^V-Strom$/i.test(model) && /^650xt$/i.test(variant)) return setExplicit(fitment, 'V-Strom 650 XT', '');
    }

    if (brand === 'YAMAHA') {
      if (/^FJ-09$/i.test(model)) return setExplicit(fitment, 'Tracer 900', 'FJ-09');
      if (/^Hw Xenter$/i.test(model)) return setExplicit(fitment, 'Xenter', variant);
      if (/^R6$/i.test(model)) return setExplicit(fitment, 'YZF-R6', variant);
      if (/^(?:XTZ12 Super Tenere|XT 1200 Z)$/i.test(model)) return setExplicit(fitment, 'Super Tenere', '1200');
      if (/^Tenere$/i.test(model) && /^700$/i.test(variant)) return setExplicit(fitment, 'Tenere 700', '');
      if (/^(?:Next Generation 50|Rocket 50)$/i.test(model)) {
        return setExplicit(fitment, 'Booster', /Next/i.test(model) ? '50 · Next Generation' : '50 · Rocket');
      }
      match = model.match(/^XSR(?:\s+(700|900))?$/i);
      if (match) {
        var xsrNumber = match[1] || (/Vmax/i.test(variant) ? '900' : '');
        if (xsrNumber) return setModelParts(fitment, 'XSR' + xsrNumber, removeMatchingParts(parts, /^(690|850|900|Vmax)$/i));
      }
      if (/^XT$/i.test(model) && parts.length && /^(125|660|1200)$/.test(parts[0])) {
        var xtNumber = parts.shift();
        var xtSuffix = parts.length && /^(R|X|Z Tenere|Super Tenere)$/i.test(parts[0]) ? ' ' + parts.shift() : '';
        if (xtNumber === '1200' && /Super Tenere/i.test(xtSuffix)) return setModelParts(fitment, 'Super Tenere', ['1200'].concat(parts));
        return setModelParts(fitment, 'XT' + xtNumber + xtSuffix, parts);
      }
      match = model.match(/^XT\s+(125|660|1200)(?:\s+([RXZ]))?/i);
      if (match) return setModelParts(fitment, 'XT' + match[1] + (match[2] ? ' ' + match[2].toUpperCase() : ''), removeMatchingParts(parts, new RegExp('^' + match[1] + '$')));
      if (/^XT X$/i.test(model) && /^660$/i.test(variant)) return setExplicit(fitment, 'XT660 X', '');
      if (/^XT Z Tenere$/i.test(model) && /^660$/i.test(variant)) return setExplicit(fitment, 'XT660 Z Tenere', '');
      if (/^(?:FSZ|FZS)$/i.test(model) && parts.length && /^(600|1000)$/.test(parts[0])) {
        return setModelParts(fitment, 'FZS' + parts.shift() + ' Fazer', removeMatchingParts(parts, /^Fazer$/i));
      }
      if (/^Fazer$/i.test(model) && /^1000$/i.test(variant)) return setExplicit(fitment, 'FZS1000 Fazer', '');
      match = model.match(/^YBR(?:\s+)?(125)?/i);
      if (match && (match[1] || (parts.length && /^125$/.test(parts[0])))) {
        if (!match[1]) parts.shift();
        return setModelParts(fitment, 'YBR125', removeMatchingParts(parts, /^125$/i));
      }
    }

    if (brand === 'TRIUMPH') {
      if (/^Speed$/i.test(model) && parts.length && /^400$/.test(parts[0])) {
        parts.shift();
        return setModelParts(fitment, 'Speed 400', parts);
      }
      if (/^Speed$/i.test(model) && /^600\s*·\s*Four$/i.test(variant)) {
        return setExplicit(fitment, 'Speed Four', '600');
      }
      match = model.match(/^(Tiger|Speed Triple)(?:\s+(\d{3,4}))?(.*)$/i);
      if (match) {
        var triumphNumber = match[2] || (parts.length && /^\d{3,4}i?$/.test(parts[0]) ? parts.shift() : '');
        if (triumphNumber) return setModelParts(fitment, match[1] + ' ' + triumphNumber.replace(/i$/i, ''), parts);
      }
    }

    if (brand === 'TGB') {
      match = model.match(/^(Blade|Target)\s+(\d{3})\b(.*)$/i);
      if (match) return setModelParts(fitment, match[1] + ' ' + match[2], [clean(match[3])].concat(parts));
    }

    if (brand === 'SYM' && /^Symphony S$/i.test(model)) return setExplicit(fitment, 'Symphony S', variant);

    if (brand === 'MOTO GUZZI' && /^1000$/i.test(model)) {
      if (/Mille\s*·\s*GT/i.test(variant)) return setExplicit(fitment, 'Mille GT', '1000');
      if (/^S$/i.test(variant)) return setExplicit(fitment, '1000 S', '');
    }

    if (brand === 'VESPA' && /^Sei$/i.test(model) && /^Giorni$/i.test(variant)) return setExplicit(fitment, 'Sei Giorni', '');

    return false;
  }
  function normalizeTmaxGeneration(fitment) {
    if (fitment[0] !== 'YAMAHA' || fitment[1] !== 'TMAX') return;
    var variant = clean(fitment[2]);
    if (/^Tech\s*Max$/i.test(variant)) variant = '560 · Techmax';
    if (/^560\s*·\s*Tech\s*Max$/i.test(variant)) variant = '560 · Techmax';
    fitment[2] = variant;

    var displacement = variant.match(/^(500|530|560)(?:\s*·|$)/);
    var from = Number(fitment[3] || 0);
    var to = Number(fitment[4] || fitment[3] || 0);
    if (!displacement || !from) return;

    var limits = {
      '500': [2001, 2011],
      '530': [2012, 2019],
      '560': [2020, Infinity]
    }[displacement[1]];
    fitment[3] = Math.max(from, limits[0]);
    fitment[4] = Math.min(to, limits[1]);
  }
  function setFamily(fitment, family, options) {
    options = options || {};
    var model = clean(fitment[1]);
    var variant = clean(fitment[2]);
    var escaped = family.replace(/[.*+?^$\{\}()|[\]\\]/g, '\\$&');
    var pattern = options.compact
      ? new RegExp('^' + escaped + '(.*)$', 'i')
      : new RegExp('^' + escaped + '(?:\\s+(.+))?$', 'i');
    var match = model.match(pattern);
    if (!match) return false;
    var suffix = clean(match[1]);
    if (options.compact && suffix && !/^[\s-]*\d/i.test(suffix)) return false;
    suffix = suffix.replace(/^[\s-]+/, '');
    fitment[1] = family;
    fitment[2] = joinVariant(suffix, variant);
    return true;
  }
  var families = {
    'APRILIA': ['Scarabeo','Dorsoduro','Caponord','Tuono','Rally','AF1','RX','SX'],
    'BENELLI': ['Leoncino','TRK','TNT','BN'],
    'BMW': ['R nineT','C','F','G','K','R','S','M'],
    'HONDA': ['Africa Twin','Transalp','Forza','Shadow','Vision','Bali','Cbf','VTX','VTR','CBR','CRF','VFR','NC','SH','CB','CG'],
    'KTM': ['Super Adventure','Super Duke','Supermoto','Adventure','EXC-F','EXC','Duke','SX'],
    'KYMCO': ['Super 8','Super 9','Top Boy','Agility','People','Vitality','Smaxxer','Maxxer','Filly','Fever','KXR','MXU','Xciting','Vivo','Yup'],
    'PIAGGIO': ['Vespa PX E Dt','Vespa Primavera','Vespa LX','Vespa S','Vespa Car','Ape','Beverly','Fly','Free','Liberty','Medley','MP3','NRG','Porter','Quargo','Typhoon','Skipper','Quartz','Storm','NTT','SKR','BV','X9','ZIP'],
    'SUZUKI': ['V-Strom','V-STROM','Burgman','Bandit','Marauder','GSX-F','GSX-S','GSX','RF','SV','TL','Rg'],
    'VESPA': ['Primavera','Sprint','GTS','GTV','LXV','LX','GT'],
    'YAMAHA': ['Super Tenere','Midnight Star','Cityliner','Majesty','Aerox','Nmax','NMAX','TMAX','XMAX','XSR','FZS','YBR','Doodo',"Teo's",'Xenter','Vmax','XT'],
    'CAGIVA': ['Mito','Prima'],
    'DERBI': ['Senda Sm'],
    'DUCATI': ['1199 Panigale','Sportclassic','Streetfighter','Hypermotard','Multistrada','Scrambler','Monster','748','916','996'],
    'GILERA': ['Gilera Storm','Smt'],
    'KAWASAKI': ['VERSYS-X','Versys','Vulcan','Ninja','KFX','VN','ZXR','ZZR','Z'],
    'MALAGUTI': ['Yesterday','Centro','Ciak'],
    'MBK': ['Booster','Spirit'],
    'MOTO GUZZI': ['California','Stelvio','Nevada','Breva','Griso','Norge','Quota'],
    'PEUGEOT': ['Kisbee','Jet Force'],
    'SYM': ['Symphony']
  };

  function normalizeExplicitFitment(fitment) {
    var brand = fitment[0];
    var model = fitment[1];
    var variant = fitment[2];
    var match;

    if (brand === 'APRILIA') {
      if (/^Pegaso Strada- FACTORY-TRAIL$/i.test(model)) {
        return setExplicit(fitment, 'Pegaso', appendVariant(variant, 'Strada / Factory / Trail'));
      }
      if (model === '125 IE Light') return setExplicit(fitment, 'Scarabeo', '125 · IE Light');
      if (model === 'Light') return setExplicit(fitment, 'Scarabeo', 'Light');
      if (model === '660 4T 8v' && /^RS$/i.test(variant)) {
        return setExplicit(fitment, 'RS', '660 · 4T 8v');
      }
      if (/^Area$/i.test(model) && /^51$/i.test(variant)) {
        return setExplicit(fitment, 'Area 51', '');
      }
      if (/^Sport$/i.test(model) && /^(\d{2,4})\s*·\s*City$/i.test(variant)) {
        return setExplicit(fitment, 'Sport City', variant.match(/^(\d{2,4})/)[1]);
      }
      if (/^Sport City Cube$/i.test(model)) {
        return setExplicit(fitment, 'Sport City', appendVariant(variant, 'Cube'));
      }
      if (/^RSV Tuono$/i.test(model)) return setExplicit(fitment, 'Tuono', variant);
      if (/^Rxv 4\.5 \/ 5\.5$/i.test(model)) return setExplicit(fitment, 'RXV', variant);
      if (/^Sxv 4\.5 \/ 5\.5$/i.test(model)) return setExplicit(fitment, 'SXV', variant);
    }

    if (brand === 'BENELLI') {
      if (/^302s$/i.test(model)) return setExplicit(fitment, '302S', variant);
      if (/^502$/i.test(model) && /^C$/i.test(variant)) return setExplicit(fitment, '502C', '');
      if (/^752$/i.test(model) && /^S$/i.test(variant)) return setExplicit(fitment, '752S', '');
    }

    if (brand === 'BMW' && /^HP4 1000$/i.test(model)) {
      return setExplicit(fitment, 'HP4', joinUniqueParts('1000', variant));
    }

    if (brand === 'BUELL' && /^XB9R$/i.test(model)) {
      return setExplicit(fitment, 'Firebolt', joinUniqueParts('XB9R', variant));
    }

    if (brand === 'CFMoto') {
      if (/^450\s*MT$/i.test(model)) return setExplicit(fitment, '450MT', variant);
      if (/^800\s*MT$/i.test(model)) return setExplicit(fitment, '800MT', variant);
    }

    if (brand === 'DERBI') {
      match = model.match(/^Boulevard\s+(.+)$/i);
      if (match) return setExplicit(fitment, 'Boulevard', appendVariant(variant, match[1]));
    }

    if (brand === 'DUCATI') {
      if (/^659 Learner Legal$/i.test(model)) {
        return setExplicit(fitment, 'Monster', joinUniqueParts('659', 'Learner Legal', variant));
      }
      if (/^Diesel$/i.test(model)) return setExplicit(fitment, 'Monster', joinUniqueParts('Diesel', variant));
      if (/^848$/i.test(model)) return setExplicit(fitment, 'Superbike', joinUniqueParts('848', variant));
      match = model.match(/^(?:Superbike\s+)?(899|1199)\s+Panigale(?:\s+(.+))?$/i);
      if (match) {
        return setExplicit(fitment, 'Panigale', joinUniqueParts(match[1], match[2], variant));
      }
      if (/^Desert$/i.test(model) && /^X(?:\s+Rally)?$/i.test(variant)) {
        return setExplicit(fitment, 'DesertX', /Rally/i.test(variant) ? 'Rally' : '');
      }
      if (/^GT$/i.test(model)) return setExplicit(fitment, 'Sportclassic', variant);
      if (/^Paul$/i.test(model) && /^1000\s*·\s*Smart$/i.test(variant)) {
        return setExplicit(fitment, 'Paul Smart', '1000');
      }
      if (/^Xdiavel$/i.test(model)) return setExplicit(fitment, 'XDiavel', variant);
    }

    if (brand === 'GILERA') {
      match = model.match(/^Gilera Storm(?:\s+(.+))?$/i);
      if (match) return setExplicit(fitment, 'Storm', joinUniqueParts(match[1], variant));
      match = model.match(/^Typhoon\s+(X(?:-XR)?)$/i);
      if (match) return setExplicit(fitment, 'Typhoon', appendVariant(variant, match[1].toUpperCase()));
    }

    if (brand === 'Harley-Davidson') {
      if (/^XR1200$/i.test(model)) return setExplicit(fitment, 'XR', joinUniqueParts('1200', variant));
      if (/^Electra$/i.test(model) && /^Glide$/i.test(variant)) return setExplicit(fitment, 'Electra Glide', '');
      if (/^Road$/i.test(model) && /^King(?:\s+Custom)?$/i.test(variant)) {
        return setExplicit(fitment, 'Road King', /Custom/i.test(variant) ? 'Custom' : '');
      }
    }

    if (brand === 'HONDA') {
      if (/^SH Mode$/i.test(model)) return setExplicit(fitment, 'SH Mode', variant);
      if (/^CB F Hornet S$/i.test(model)) {
        return setExplicit(fitment, 'CB', appendVariant(variant, 'F Hornet S'));
      }
      if (/^Silver$/i.test(model)) {
        return setExplicit(fitment, 'Silver Wing', clean(variant).replace(/\s*·\s*Wing$/i, ''));
      }
      if (/^Fjs 400 [AD] SW-T$/i.test(model)) {
        match = model.match(/^Fjs (400) ([AD]) SW-T$/i);
        return setExplicit(fitment, 'SW-T', joinUniqueParts(match[1], match[2], variant));
      }
      if (/^Fjs 600 [AD]?\s*Silver Wing$/i.test(model)) {
        match = model.match(/^Fjs (600)\s*([AD])?/i);
        return setExplicit(fitment, 'Silver Wing', joinUniqueParts(match[1], match[2], variant));
      }
      if (/^Fes 125 Pantheon$/i.test(model)) return setExplicit(fitment, 'Pantheon', joinUniqueParts('125', variant));
      match = model.match(/^Nes (125|150) @ \/ Arobase$/i);
      if (match) return setExplicit(fitment, 'Arobase', joinUniqueParts(match[1], variant));
      if (/^Nhx Lead$/i.test(model)) return setExplicit(fitment, 'Lead', variant);
      match = model.match(/^Pes(?:\s+(125|150) PS I)?$/i);
      if (match) return setExplicit(fitment, 'PS', joinUniqueParts(match[1], variant, match[1] ? 'i' : ''));
      match = model.match(/^Ses (125) Dylan$/i);
      if (match) return setExplicit(fitment, 'Dylan', joinUniqueParts(match[1], variant));
      if (/^VFR X Cross Runner$/i.test(model)) {
        return setExplicit(fitment, 'VFR', appendVariant(variant, 'X Crossrunner'));
      }
      match = model.match(/^Vt(?:\s+(750 S|1300 Interstate))?$/i);
      if (match) return setExplicit(fitment, 'VT', joinUniqueParts(match[1], variant));
      if (/^NT1100$/i.test(model)) return setExplicit(fitment, 'NT', joinUniqueParts('1100', variant));
      if (/^NX500$/i.test(model)) return setExplicit(fitment, 'NX', joinUniqueParts('500', variant));
      if (/^NSS750$/i.test(model)) return setExplicit(fitment, 'Forza', joinUniqueParts('750', variant));
      if (/^GL1800$/i.test(model) && /Gold Wing/i.test(variant)) return setExplicit(fitment, 'Gold Wing', '1800');
      if (/^XL750 Transalp$/i.test(model)) return setExplicit(fitment, 'Transalp', joinUniqueParts('750', variant));
      if (/^(HRC|Rojo|Rouge)$/i.test(model)) return setExplicit(fitment, 'CBR', joinUniqueParts(model, variant));
    }

    if (brand === 'KAWASAKI') {
      if (/^Zr 800$/i.test(model)) return setExplicit(fitment, 'Z', joinUniqueParts('800', variant));
      match = model.match(/^VN(?:\s+(.+))?$/i);
      if (match) return setExplicit(fitment, 'Vulcan', joinUniqueParts(match[1], variant));
    }

    if (brand === 'KYMCO' && /^Top$/i.test(model) && /Boy/i.test(variant)) {
      return setExplicit(fitment, 'Top Boy', clean(variant).replace(/\s*·\s*Boy$/i, ''));
    }

    if (brand === 'MALAGUTI' && /^Cnk$/i.test(model) && /Dragon/i.test(variant)) {
      return setExplicit(fitment, 'Cnk', variant.replace(/Dragon/ig, 'Drakon'));
    }

    if (brand === 'MBK') {
      if (/^150 Flame$/i.test(model)) return setExplicit(fitment, 'XC', joinUniqueParts('150', 'Flame', variant));
      if (/^XC125$/i.test(model)) return setExplicit(fitment, 'XC', joinUniqueParts('125', variant));
      match = model.match(/^Spirit(?:\s+(.+))?$/i);
      if (match) return setExplicit(fitment, 'Booster', joinUniqueParts('Spirit', match[1], variant));
      if (/^Next$/i.test(model) && /Generation/i.test(variant)) {
        return setExplicit(fitment, 'Booster', joinUniqueParts('Next Generation'));
      }
      if (/^(Rocket|Track)$/i.test(model)) return setExplicit(fitment, 'Booster', joinUniqueParts(model, variant));
      if (/^Tuack 502$/i.test(model)) return setExplicit(fitment, 'Booster', 'Tuack 502');
    }

    if (brand === 'MOTO GUZZI') {
      if (/^1200 Sport 8v$/i.test(model)) return setExplicit(fitment, '1200 Sport', joinUniqueParts('8V', variant));
      if (/^Sport$/i.test(model) && /^1200$/i.test(variant)) return setExplicit(fitment, '1200 Sport', '');
      if (/^Sport IE$/i.test(model) && /^1100$/i.test(variant)) return setExplicit(fitment, '1100 Sport', 'IE');
      if (/^Metal 1100$/i.test(model)) return setExplicit(fitment, 'Metal', joinUniqueParts('1100', variant));
      if (/^V7 Classic$/i.test(model)) return setExplicit(fitment, 'V7', appendVariant(variant, 'Classic'));
    }

    if (brand === 'MOTO MORINI' && /^9$/i.test(model) && /^1⁄2$/i.test(variant)) {
      return setExplicit(fitment, '9 1/2', '');
    }

    if (brand === 'MV AGUSTA' && /^Turismo$/i.test(model) && /^Veloce$/i.test(variant)) {
      return setExplicit(fitment, 'Turismo Veloce', '');
    }

    if (brand === 'PEUGEOT' && /^Jet$/i.test(model) && /^Force$/i.test(variant)) {
      return setExplicit(fitment, 'Jet Force', '');
    }
    if (brand === 'PEUGEOT' && /^Vivacity 50 3$/i.test(model)) {
      return setExplicit(fitment, 'Vivacity', joinUniqueParts('50', '3', variant));
    }

    if (brand === 'PIAGGIO') {
      if (/^Vespa Car$/i.test(model)) return setExplicit(fitment, 'Ape', joinUniqueParts('Car', variant));
      if (/^Vespa$/i.test(model)) return setExplicit(fitment, 'Vespa ET', variant);
      match = model.match(/^BV(?:\s+(.+))?$/i);
      if (match) return setExplicit(fitment, 'Beverly', joinUniqueParts(match[1], variant, 'BV'));
    }

    if (brand === 'SUZUKI') {
      if (/^GSX F$/i.test(model)) {
        var gsxfNumber = (variant.match(/^(600|750)(?:\s*·|$)/) || [])[1] || '';
        if (gsxfNumber) return setExplicit(fitment, 'GSX-F ' + gsxfNumber, clean(variant).replace(new RegExp('^' + gsxfNumber + '(?:\\s*·\\s*)?'), ''));
        return setExplicit(fitment, 'GSX-F', variant);
      }
      if (/^GSX W$/i.test(model)) return setExplicit(fitment, 'GSX', appendVariant(variant, 'W'));
      if (/^SV S$/i.test(model)) return setExplicit(fitment, 'SV', appendVariant(variant, 'S'));
      match = model.match(/^GZ\s*250$/i);
      if (match) return setExplicit(fitment, 'GZ', joinUniqueParts('250', variant));
      if (/^Gz Marauder$/i.test(model)) return setExplicit(fitment, 'Marauder', variant);
    }

    if (brand === 'SYM' && /^Adx$/i.test(model)) return setExplicit(fitment, 'ADX', variant);

    if (brand === 'TGB') {
      match = model.match(/^(Blade|Target)\s+(.+)$/i);
      if (match) return setExplicit(fitment, match[1], joinUniqueParts(match[2], variant));
    }

    if (brand === 'DERBI') {
      match = model.match(/^Rambla\s+(125|250|300)$/i);
      if (match) return setExplicit(fitment, 'Rambla', joinUniqueParts(match[1], variant));
    }

    if (brand === 'TRIUMPH') {
      match = model.match(/^Speed Triple\s+(.+)$/i);
      if (match) return setExplicit(fitment, 'Speed Triple', joinUniqueParts(match[1], variant));
      match = model.match(/^Tiger\s+(.+)$/i);
      if (match) return setExplicit(fitment, 'Tiger', joinUniqueParts(match[1], variant));
    }

    if (brand === 'YAMAHA') {
      if (/^FSZ$/i.test(model)) return setExplicit(fitment, 'FZS', variant);
      if (/^YQ$/i.test(model)) return setExplicit(fitment, 'Aerox', variant);
      match = model.match(/^YQ Aerox(?:\s*\/)?$/i);
      if (match) return setExplicit(fitment, 'Aerox', variant);
      if (/^YQ 50$/i.test(model)) return setExplicit(fitment, 'Aerox', joinUniqueParts('50', variant));
      match = model.match(/^Dragstar\s+(.+)$/i);
      if (match) return setExplicit(fitment, 'Dragstar', joinUniqueParts(match[1], variant));
      match = model.match(/^(?:Midnight|Midnight Star|XVS Midnight Star)(?:\s+(.+))?$/i);
      if (match) return setExplicit(fitment, 'Midnight Star', joinUniqueParts(match[1], variant));
      if (/^Xn (125|150)$/i.test(model)) {
        return setExplicit(fitment, "Teo's", joinUniqueParts(model.match(/\d+/)[0], variant));
      }
      if (/^(?:Dt(?:\s+.*)?|RMS X-LIMIT S\.m|RSM(?:\s+.*)?|S\.m\.dt 50|X-LIMIT 50 Sm)$/i.test(model)) {
        var dtSuffix = model.replace(/^Dt\s*/i, '').replace(/^RMS\s*/i, '').replace(/^RSM\s*/i, '');
        return setExplicit(fitment, 'DT', joinUniqueParts(dtSuffix, variant));
      }
    }

    return false;
  }

  function normalizeFitment(fitment) {
    if (!Array.isArray(fitment)) return;
    fitment[0] = clean(fitment[0]);
    fitment[1] = clean(fitment[1]);
    fitment[2] = clean(fitment[2]);

    if (fitment[0] === 'BENELLI' && /^adiva$/i.test(fitment[1])) fitment[0] = 'ADIVA';
    if (/^CFMOTO$/i.test(fitment[0])) fitment[0] = 'CFMoto';
    if (/^HARLEY-DAVIDSON$/i.test(fitment[0])) fitment[0] = 'Harley-Davidson';

    if (normalizeDistinctCommercialModel(fitment)) {
      normalizeTmaxGeneration(fitment);
      return;
    }
    if (normalizeExplicitFitment(fitment)) return;

    if (fitment[0] === 'YAMAHA') {
      var mtModel = fitment[1].match(/^MT[\s-]*(03|07|09|10|25)$/i);
      var mtVariant = /^MT$/i.test(fitment[1]) ? splitLeadingNumeric(fitment[2]) : null;
      if (mtModel) fitment[1] = 'MT-' + mtModel[1];
      if (mtVariant && /^(03|07|09|10|25)$/.test(mtVariant.number)) {
        fitment[1] = 'MT-' + mtVariant.number;
        fitment[2] = mtVariant.rest;
      }
      var tracerModel = fitment[1].match(/^Tracer\s+(700|900)$/i);
      var tracerVariant = splitLeadingNumeric(fitment[2]);
      if (tracerModel) fitment[1] = 'Tracer ' + tracerModel[1];
      if (/^Tracer(?:\s+(700|900))?$/i.test(fitment[1]) && tracerVariant && /^(700|900)$/.test(tracerVariant.number)) {
        fitment[1] = 'Tracer ' + tracerVariant.number;
        fitment[2] = tracerVariant.rest;
      }
    }

    var compactFamilies = {
      'BENELLI': ['BN'],
      'HONDA': ['CB','CBR','CRF','NC','VFR'],
      'SUZUKI': ['GSX','SV','TL'],
      'KAWASAKI': ['Z'],
      'YAMAHA': ['YBR']
    };
    var list = families[fitment[0]] || [];
    for (var i = 0; i < list.length; i += 1) {
      var compact = (compactFamilies[fitment[0]] || []).indexOf(list[i]) !== -1;
      if (setFamily(fitment, list[i], { compact: compact })) break;
    }

    fitment[1] = fitment[1]
      .replace(/^GSX\s+(\d+)\s*·?\s*R$/i, 'GSX')
      .replace(/^(\d+)mt$/i, '$1 MT');

    if (fitment[0] === 'YAMAHA' && /^Nmax$/i.test(fitment[1])) fitment[1] = 'NMAX';
    normalizeTmaxGeneration(fitment);
  }

  function moveModelTrimToVariant(fitment) {
    if (!Array.isArray(fitment)) return;
    var brand = fitment[0];
    var model = clean(fitment[1]);
    var variant = clean(fitment[2]);
    var match;

    /* Families explicitly required as a single second-level choice. */
    if (brand === 'KYMCO') {
      match = model.match(/^Agility(?:\s+(.+))?$/i);
      if (match && match[1]) return setExplicit(fitment, 'Agility', joinUniqueParts(match[1], variant));
      match = model.match(/^People(?:\s+(GTi|One|S))$/i);
      if (match) return setExplicit(fitment, 'People', joinUniqueParts(match[1], variant));
    }

    /* A commercial model code stays in level two; its equipment/edition moves
       to level three. This avoids a base model plus duplicated child entries. */
    if (brand === 'BMW') {
      match = model.match(/^(F \d{3} GS|G \d{3} GS|R \d{4} GS|R \d{4} R)\s+(Adventure|Dakar|Sertao|Rockster|LC)$/i);
      if (match) return setExplicit(fitment, match[1], joinUniqueParts(match[2], variant));
      match = model.match(/^(R nineT)\s+(Pure|Scrambler|Urban G\/S)$/i);
      if (match) return setExplicit(fitment, match[1], joinUniqueParts(match[2], variant));
    }

    if (brand === 'BENELLI') {
      match = model.match(/^(TRK \d{3})\s+X$/i);
      if (match) return setExplicit(fitment, match[1], joinUniqueParts('X', variant));
      match = model.match(/^(Leoncino \d{3})\s+Trail$/i);
      if (match) return setExplicit(fitment, match[1], joinUniqueParts('Trail', variant));
    }

    if (brand === 'HONDA') {
      match = model.match(/^(CBR(?:600F|900RR|1000RR))\s+(Sport|Fireblade)$/i);
      if (match) return setExplicit(fitment, match[1], joinUniqueParts(match[2], variant));
    }

    if (brand === 'KAWASAKI') {
      match = model.match(/^(Vulcan \d{3,4})\s+(Classic|Nomad|Vaquero|Voyager)$/i);
      if (match) return setExplicit(fitment, match[1], joinUniqueParts(match[2], variant));
    }

    if (brand === 'SUZUKI') {
      match = model.match(/^(V-Strom \d{3,4})\s+(XT|DE)$/i);
      if (match) return setExplicit(fitment, match[1], joinUniqueParts(match[2], variant));
    }
  }

  /* Only the presentation of a version is canonicalized here. The token set is
     preserved, so the selected option and the results page keep matching the
     same catalogue rows while spelling/order duplicates disappear. */
  function normalizeVariantDisplay(fitment) {
    if (!Array.isArray(fitment)) return;
    var value = clean(fitment[2])
      .replace(/\bS[- ]?PACKAGE\b/ig, 'S Package')
      .replace(/\b(4T|2T)\s+([48])v\b/ig, function (_, cycle, valves) { return cycle.toUpperCase() + ' ' + valves + 'V'; })
      .replace(/\b([48])v\b/ig, function (_, valves) { return valves + 'V'; });
    if (fitment[0] === 'KAWASAKI' && fitment[1] === 'ZXR') {
      value = value.replace(/\bk1\b/ig, 'K1').replace(/\bxx\b/ig, 'XX');
    }
    if (fitment[0] === 'YAMAHA' && fitment[1] === 'DT') {
      value = value
        .replace(/\bX-LIMIT\s+50\s+S\.?m\b/ig, '50 · X-LIMIT SM')
        .replace(/^50\s*·\s*SM-DT\s+50$/i, '50 · SM-DT')
        .replace(/\bS\.?m\.?dt\b/ig, 'SM-DT')
        .replace(/\bS\.?m\b/ig, 'SM');
    }
    if (!value) {
      fitment[2] = '';
      return;
    }

    var rawParts = variantParts(value);
    var numeric = [];
    var words = [];
    rawParts.forEach(function (part) {
      part = clean(part).replace(/^-+/, '');
      var leading = part.match(/^(\d{2,4})\s+(.+)$/);
      var trailing = part.match(/^(.+?)\s+(\d{2,4})$/);
      if (leading) {
        numeric.push(leading[1]);
        words.push(leading[2]);
      } else if (trailing) {
        numeric.push(trailing[2]);
        words.push(trailing[1]);
      } else if (/^\d{2,4}$/.test(part)) {
        numeric.push(part);
      } else {
        words.push(part);
      }
    });

    var seenNumbers = {};
    numeric = numeric.filter(function (number) {
      if (seenNumbers[number]) return false;
      seenNumbers[number] = true;
      return true;
    });
    if (numeric.length === 1) {
      words = words.map(function (part) {
        return clean(part.replace(new RegExp('^' + numeric[0] + '\\s+'), ''));
      }).filter(Boolean);
    }

    var seenWords = {};
    var seenTokens = {};
    words = words.map(function (part) {
      var tokens = clean(part).split(/\s+/);
      return tokens.filter(function (token) {
        var tokenKey = token.toLocaleLowerCase('it');
        if (seenTokens[tokenKey]) return false;
        seenTokens[tokenKey] = true;
        return true;
      }).join(' ');
    }).filter(function (part) {
      var partKey = part.toLocaleLowerCase('it');
      if (!part || seenWords[partKey]) return false;
      seenWords[partKey] = true;
      return true;
    });

    fitment[2] = clean(numeric.concat(words.length ? [words.join(' ')] : []).join(' · '));
    if (fitment[0] === 'YAMAHA' && fitment[1] === 'DT') {
      fitment[2] = fitment[2]
        .replace(/^50\s*·\s*SM X-LIMIT$/i, '50 · X-LIMIT SM')
        .replace(/^50\s*·\s*SM-DT(?:\s+50)?$/i, '50 · SM-DT');
    }
  }

  function expandCompoundFitments(fitments, entry) {
    var expanded = [];
    (fitments || []).forEach(function (fitment) {
      var brand = clean(fitment[0]);
      var model = clean(fitment[1]);
      var variant = clean(fitment[2]);
      var match;
      if (brand === 'KTM / HUSQVARNA / GASGAS') return;
      if (
        entry &&
        entry.s === '0306' &&
        brand === 'APRILIA'
      ) {
        /* FAR catalogue 2026-2027 lists 0306 only for Moto Guzzi V11,
           Scura, Breva and Ballabio. The Aprilia rows in the source export
           were an asymmetric carry-over that does not exist on paired 0307. */
        return;
      }
      if (
        entry &&
        /^(?:retrovisore-sinistro-per-honda-sh-mode-125|retrovisore-destro-honda-sh-mode-125)$/i.test(entry.h || '') &&
        brand === 'HONDA' &&
        /^SH$/i.test(model)
      ) {
        var shModeFrom = Math.max(Number(fitment[3] || 0), 2014);
        var shModeTo = Number(fitment[4] || fitment[3] || 0);
        if (!shModeTo || shModeFrom <= shModeTo) {
          expanded.push([brand, 'SH Mode', '125', shModeFrom || '', shModeTo || '']);
        }
        return;
      }
      if (
        entry &&
        entry.s === '6440' &&
        brand === 'SUZUKI' &&
        /^GSX-F$/i.test(model) &&
        !variant
      ) {
        /* Redundant source rows: the same entry already contains complete
           GSX600F and GSX750F ranges for these years. */
        return;
      }
      if (
        entry &&
        entry.h === 'retrovisore-sinistro-honda-sh-125-150-2017-2020' &&
        brand === 'HONDA' &&
        /^SH$/i.test(model) &&
        /^(125|150)\s*·\s*AD$/i.test(variant)
      ) {
        expanded.push([brand, model, variant.match(/^(125|150)/)[1], fitment[3], fitment[4]]);
        return;
      }
      if (
        entry &&
        entry.h === 'retrovisore-destro-honda-sh-125-150-350-dal-2020' &&
        brand === 'HONDA' &&
        /^SH$/i.test(model) &&
        /^SH\s*125\s*-\s*150$/i.test(variant)
      ) {
        expanded.push([brand, model, '125', fitment[3], fitment[4]]);
        expanded.push([brand, model, '150', fitment[3], fitment[4]]);
        return;
      }
      if (brand === 'HONDA' && /^NC$/i.test(model) && /^750\s*·\s*NC X NC S$/i.test(variant)) {
        expanded.push([brand, 'NC750X', '', fitment[3], fitment[4]]);
        expanded.push([brand, 'NC750S', '', fitment[3], fitment[4]]);
        return;
      }
      if (brand === 'HONDA' && /^CRF300L\s*\/\s*CRF300 Rally$/i.test(model)) {
        expanded.push([brand, 'CRF300L', '', fitment[3], fitment[4]]);
        expanded.push([brand, 'CRF300 Rally', '', fitment[3], fitment[4]]);
        return;
      }
      if (
        entry &&
        entry.h === 'retrovisore-sinistro-yamaha-fzs-600-fazer-carbon-look' &&
        brand === 'YAMAHA' &&
        /^FZS$/i.test(model)
      ) {
        expanded.push([brand, 'FZS600 Fazer', '', fitment[3], fitment[4]]);
        expanded.push([brand, 'FZS1000 Fazer', '', fitment[3], fitment[4]]);
        return;
      }
      if (brand === 'YAMAHA' && /^R1\s*\/\s*R6$/i.test(model)) {
        expanded.push([brand, 'YZF-R1', variant, fitment[3], fitment[4]]);
        expanded.push([brand, 'YZF-R6', variant, fitment[3], fitment[4]]);
        return;
      }
      if (brand === 'YAMAHA' && /^TMAX$/i.test(model) && !variant && Number(fitment[3] || 0)) {
        var from = Number(fitment[3]);
        var to = Number(fitment[4] || fitment[3]);
        var tmaxGenerations = [
          ['500', 2001, 2011],
          ['530', 2012, 2019],
          ['560', 2020, Infinity]
        ];
        tmaxGenerations.forEach(function (generation) {
          var overlapFrom = Math.max(from, generation[1]);
          var overlapTo = Math.min(to, generation[2]);
          if (overlapFrom <= overlapTo) {
            expanded.push([brand, 'TMAX', generation[0], overlapFrom, overlapTo]);
          }
        });
        return;
      }
      if (brand === 'APRILIA' && /^RX\s*-\s*SX$/i.test(model)) {
        expanded.push([brand, 'RX', variant, fitment[3], fitment[4]]);
        expanded.push([brand, 'SX', variant, fitment[3], fitment[4]]);
        return;
      }
      match = brand === 'APRILIA'
        ? model.match(/^Rxv 4\.5 \/ 5\.5\s*-\s*Sxv 4\.5 \/ 5\.5(?:\s+(.+))?$/i)
        : null;
      if (match) {
        expanded.push([brand, 'RXV', appendVariant(variant, match[1]), fitment[3], fitment[4]]);
        expanded.push([brand, 'SXV', appendVariant(variant, match[1]), fitment[3], fitment[4]]);
        return;
      }
      expanded.push(fitment);
    });
    return expanded;
  }

  function normalizeCatalog() {
    if (!Array.isArray(window.FAR_FITMENT_SHARDS)) return false;
    window.FAR_FITMENT_SHARDS.forEach(function (shard) {
      shard.forEach(function (entry) {
        entry.f = expandCompoundFitments(entry.f, entry);
        (entry.f || []).forEach(function (fitment) {
          normalizeFitment(fitment);
          moveModelTrimToVariant(fitment);
          normalizeVariantDisplay(fitment);
        });
      });
    });
    window.FAR_FITMENT_CATALOG = {
      version: '2026-07-15-b2c-full-audit-v7-results-mobile-hotfix',
      matchingPolicy: 'exact-version-documented-year',
      entries: window.FAR_FITMENT_SHARDS.flat()
    };
    window.FAR_B2C_NORMALIZED = true;
    return true;
  }
  if (!normalizeCatalog()) window.addEventListener('DOMContentLoaded', normalizeCatalog, { once: true });
})();
